import { diInjectable } from '@di/di';
import { concatUrl } from '@studio/utils/url';
export async function registerFeaturesByFiles(files, origin, env, brandId) {
    const registerTasks = [];
    __webpack_public_path__ = origin && concatUrl(origin, '/scripts/');
    for (const file of files) {
        if (!file.id.startsWith('preload')) {
            continue;
        }
        const matches = /^([\w-]+)/.exec(file.url);
        switch (matches[1]) {
            case 'widget':
                registerTasks.push(registerWidgetFeature(env));
                break;
            case 'feed':
                registerTasks.push(registerFeedStoreFeature(env, brandId));
                break;
            case 'video':
                registerTasks.push(registerVideoFeature());
                break;
        }
    }
    await Promise.all(registerTasks);
    __webpack_public_path__ = '';
}
async function registerFeedStoreFeature(env, brandId) {
    const { FeedStore: FeedStoreC } = await import(
    /* webpackChunkName: "feed" */ './elements/feed/feed-store');
    diInjectable(4 /* Token.FEED_STORE */, FeedStoreC).withArgs(env, brandId);
}
async function registerWidgetFeature(env) {
    const { WidgetRenderer: WidgetRendererC, WidgetAdApi: WidgetAdApiC, CreativeApi: CreativeApiC, TimelineApi: TimelineApiC } = await import(/* webpackChunkName: "widget" */ './elements/widget/widget.module');
    diInjectable(2 /* Token.WIDGET_RENDERER */, WidgetRendererC).withArgs(env);
    diInjectable(6 /* Token.WIDGET_AD_API */, WidgetAdApiC).withArgs(env);
    diInjectable(7 /* Token.CREATIVE_API */, CreativeApiC);
    diInjectable(8 /* Token.TIMELINE_API */, TimelineApiC);
}
async function registerVideoFeature() {
    const { VideoRenderer: VideoRendererC } = await import(
    /* webpackChunkName: "video" */ './elements/video/video.module');
    diInjectable(5 /* Token.VIDEO_RENDERER */, VideoRendererC);
}
